import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-range-slider',
  templateUrl: './range-slider.component.html',
  styleUrls: ['./range-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class RangeSliderComponent {
    @Input() value: number | null = null;
    @Input() disabled = false;
    @Input() min = 0;
    @Input() max = 100;
    @Input() step = 1;

    @Output() valueChange = new EventEmitter<number | null>();

    onChangeValue(event: number | null): void {
        this.value = event;
        this.valueChange.emit(event);
    }
}
